var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrybox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "38px",
    viewBox: "0 0 104 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE9Bicon/truck/drybox2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.646923,9 L97,19.3531095 L97,31 L75,31 L75,9 L88.646923,9 Z",
    id: "Combined-Shape",
    stroke: "#4F7CB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 90,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 70,
    height: 30
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-27",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 59,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-26",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 6,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 17,
    cy: 33,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrybox);
export default __webpack_public_path__ + "static/media/drybox.3de5f0a5781663fc7c44adc2c44a51a2.svg";
export { ForwardRef as ReactComponent };